import {useEffect, useState} from "react";
import PC from "../PC";
import Button from "../Button";
import {useTranslation} from "react-i18next";
import useNotice from "../../hooks/useNotice";
import cookies from "../../utils/cookies";
import {useCmsUserContactAdd} from "../../api/cmsUserContact";

function CallsUsForm() {
  const [query, setQuery] = useState({});
  const { submit, loading } = useCmsUserContactAdd();
  const { t } = useTranslation();
  const notice = useNotice();
  
  
  const inputHandle = (e, key) => {
    setQuery({
      ...query,
      [key]: e.target.value
    });
  };
  
  const submitMessage = async () => {
    const { contactName, email, message, mobileno } = query;
    if (!contactName || !email || !message || !mobileno) {
      notice.warn(t("请填写完整数据"));
      return false
    }
    let { data, error } = await submit({
      ...query,
      agentId: cookies.getAgentInfo().agentId,
    });
    if (data) {
      notice.success(t('发送成功'));
      setQuery({});
    }
  };
  
  return (
    <PC>
      <div className="border-[2px] rounded-[12px] my-[70px] mx-auto w-[800px] pt-[50px] pb-[100px] px-[100px] text-center">
        <h1 className="text-center text-[32px] mb-[25px]">{t('发送消息')}</h1>
        <div className="flex items-center mb-[25px]">
          <label className="w-[125px] inline-block text-right mr-[20px]">{t('名称')} : </label>
          <input type="text"
                 onChange={(e) => {
                   inputHandle(e, 'contactName');
                 }}
                 placeholder={t('请输入您的昵称')}
                 className="border p-[12px] w-[400px]"/>
        </div>
        <div className="flex items-center mb-[25px]">
          <label className="w-[125px] inline-block text-right mr-[20px]">{t('邮箱')} : </label>
          <input type="text"
                 onChange={(e) => {
                   inputHandle(e, 'email');
                 }}
                 placeholder={t('请输入您的邮箱')}
                 className="border p-[12px] w-[400px]"/>
        </div>
        <div className="flex items-center mb-[25px]">
          <label className="w-[125px] inline-block text-right mr-[20px]">
            {t('手机号码')} :
          </label>
          <input type="text"
                 onChange={(e) => {
                   inputHandle(e, 'mobileno');
                 }}
                 placeholder={t('请输入您的手机号码')}
                 className="border p-[12px] w-[400px]"/>
        </div>
        <div className="flex items-center mb-[50px]">
          <label className="w-[125px] inline-block text-right mr-[20px]">{t('消息')} : </label>
          <textarea type="text"
                    onChange={(e) => {
                      inputHandle(e, 'message');
                    }}
                    className="border p-[12px] w-[400px]"/>
        </div>
        <Button className="w-[240px] bg-[#333] text-[#FFF4D8] py-[15px] text-[16px]"
                loading={loading}
                onClick={submitMessage}>
          {t('提交')}
        </Button>
      </div>
    </PC>
  );
}

export default CallsUsForm;
